export const dataStore = {
  access_token: "access_token",
  refresh_token: "refresh_token",
  login_code: "login_code",
  active_tab: "active_tab",
};
